import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import img1 from "../../assets/service-web.jpg";
import img2 from "../../assets/service-seo.png";
import img3 from "../../assets/service-digital.png";
import './servicesecton.css';
import { useNavigate } from "react-router-dom";


function Servicesection() {
  


  const navigate = useNavigate();

    useEffect(() => {
      AOS.init({
        duration: 1000, // Animation duration
        once: true,     // Only animate once
      });
    }, []);

 const handleLearn = () => {
    navigate("/service");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <div className="service-section" style={{ marginTop: "80px" }}>
      <div className='container'>

        {/* Header Section */}
        <div className="header-textt" data-aos="fade-up">
          <h3>What We Do</h3>
          <h2>Services We Provide</h2>
          <p>
            From website development to digital marketing, we provide end-to-end solutions 
            to elevate your online presence and drive growth. Let’s build success together!
          </p>
        </div>

        {/* Service Cards */}
        <div className="service-cards">
          {/* Card 1 - Fade Right */}
          <div className="service-card" data-aos="fade-right">
            <img src={img1} alt="Web Development" />
            <h3>Web Development</h3>
            <p>We bring your vision online with seamless, responsive design tailored to your needs.</p>
            <button className='main-button' onClick={ handleLearn}>Learn More</button>
          </div>

          {/* Card 2 - Fade Up */}
          <div className="service-card" data-aos="fade-up">
            <img src={img2} alt="SEO Optimization" />
            <h3>SEO Optimization</h3>
            <p>Enhance your online visibility and drive targeted traffic with our expert SEO services.</p>
            <button className='main-button' onClick={ handleLearn}>Learn More</button>
          </div>

          {/* Card 3 - Fade Left */}
          <div className="service-card" data-aos="fade-left">
            <img src={img3} alt="Digital Marketing" />
            <h3>Digital Marketing</h3>
            <p>Grow your business and connect with your audience through our digital marketing services.</p>
            <button className='main-button' onClick={ handleLearn}>Learn More</button>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Servicesection;
